<template>
  <Layout>
    <div class="sidenav col-md-6 col-sm-12">
      <div class="col-md-7 col-lg-7 col-xl-7 mx-auto">
        <h2 class="text-light" style="margin-top:35vh">
          FDSU Docs
        </h2>
        <p class="text-light">
          {{ $t('pages.login.message') }}
        </p>
      </div>
    </div>

    <div class="main">
      <div class="col-md-10 col-lg-10 col-xl-8 col-sm-12 mx-auto">
        <div class="login-form">
          <div class="row">
            <div class="col-12">
              <img class="mb-2 mt-4 ml-3" src="@/assets/images/fdsu-docs.png" alt="" width="160">
              <h5 class="mb-2 ml-3" style="color:#071260;">
                {{$t('pages.login.connectedToDinFlow')}}
              </h5>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="card-body">
              <b-form class="p-2" @submit.prevent="tryToLogIn">
                <b-alert
                        v-model="isAuthError"
                        variant="danger"
                        class="mt-3"
                        dismissible
                >{{ authError }}</b-alert>
                
                <div v-if="!isMail" class="alert alert-danger" role="alert">
                    {{ $t('pages.login.enterValidEmail') }}
                </div>

                <div
                    v-if="notification.message"
                    :class="'alert ' + notification.type"
                >
                  {{ notification.message }}
                </div>
                <b-form-group
                        id="input-group-1"
                        label="Identifiant"
                        label-for="input-1"
                >
                  <b-form-input
                          id="input-1"
                          v-model="email"
                          type="text"
                          maxlength="50"
                          placeholder="Email"
                          :class="{ 'is-invalid': submitted && $v.email.$error }"
                  ></b-form-input>
                  <div
                          v-if="submitted && $v.email.$error"
                          class="invalid-feedback"
                  >
                    <span v-if="!$v.email.required">{{$t('pages.login.emailRequired')}}</span>
                    <span v-if="!$v.email.email">{{$t('pages.login.enterValidEmail')}}</span>
                  </div>
                </b-form-group>

                <b-form-group
                        id="input-group-2"
                        label="Mot de passe"
                        label-for="input-2"
                >
                  <b-form-input
                          id="input-2"
                          v-model="password"
                          type="password"
                          maxlength="50"
                          placeholder="Mot de passe"
                          :class="{ 'is-invalid': submitted && $v.password.$error }"
                  ></b-form-input>
                  <div
                          v-if="submitted && !$v.password.required"
                          class="invalid-feedback"
                  >
                    {{$t('pages.login.passwordRequired')}}
                  </div>
                </b-form-group>
                <!-- <div class="mt-4">
                  <label><a href="">{{$t('pages.login.forgottenPassword')}}</a></label>
                </div> -->
                <div class="mt-3">
                  <button class="btn btn-primary" type="button" disabled v-if="status.loggingIn || status.loggeduser">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
                  <b-button type="submit" variant="primary" disabled v-else-if="!isMail" class="animate_animated animate__bounceIn">
                    {{$t('pages.login.connexion')}}
                  </b-button>
                  <b-button type="submit" variant="primary" v-else class="animate_animated animate__bounceIn">
                    {{$t('pages.login.connexion')}}
                  </b-button>
                </div>                
              </b-form>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      isLoading: false,
      emailError : null,
      isMail: true
    };
  },
  validations: {
    email: { required, email },
    password: { required },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  watch: {
    email: function() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.isMail = re.test(this.email);
    }
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      // stop here if form is invalid
        this.$v.$touch();
        this.isLoading = true;
        const { email, password } = this;
          if (email && password) {
            this.login({ email, password }).then(() => {
              this.isLoading = false;
            });
          }
      }
    }
};
</script>

<style scoped>
  .sidenav {
    height: 100%;
    background-color: #071260;
    background-image: url('/banner.jpg');
    /* background: linear-gradient(30deg,#071260 50%,#1f397a); */
    overflow-x: hidden;
    padding-top: 20px;

  }

  .main {
    height: 100%;
    padding: 0px 10px;
  }

  @media screen and (max-height: 800px) {
    .sidenav {
      width: 0%;
    }
    .main {
      width: 100%;
    }
  }

  @media screen and (max-width: 450px) {
    .login-form{
      margin-top: 10%;
    }
    .sidenav {
      display:none;
    }
  }

  @media screen and (min-width: 768px){
    .main{
      margin-left: 50%;
      position: fixed;
      z-index: 1;
      top: 0;
      left: 0;
      background-color: #fff;
      width: 50%;
    }

    .sidenav{
      width: 50%;
      position: fixed;
      z-index: 1;
      top: 0;
      left: 0;
    }

    .login-form{
      margin-top: 30%;
      padding: 20px;
    }

    /* .btn-primary{
      background-color: #071260 !important;
      color: #fff;
      border-color: #071260;
      border-radius: 10px;
    } */
  }
</style>
